module.exports = __webpack_public_path__ + "img/fix.9340a737.svg";